import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <h2 className="font-heading text-4xl md:text-5xl text-white leading-tight">
              SERENATTI
            </h2>
            <p className="mt-3 text-sm tracking-[0.2em] uppercase text-gold">
              Evidence-Based Skincare &amp; Healthy Aging
            </p>
            <p className="mt-6 max-w-md text-white/70 leading-relaxed">
              Plain-language skincare and healthy-aging information &mdash;
              written by a registered nurse, based on published research.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-white/60 mb-5">Explore</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-white/85 hover:text-gold transition-colors">Home</Link></li>
              <li><Link to="/learn" className="text-white/85 hover:text-gold transition-colors">Learn</Link></li>
              <li><Link to="/about" className="text-white/85 hover:text-gold transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-white/85 hover:text-gold transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-white/60 mb-5">Contact</p>
            <a
              data-testid="footer-email-link"
              href="mailto:support@serenatti.com"
              className="flex items-center gap-3 text-sm text-white/85 hover:text-gold transition-colors"
            >
              <Mail size={16} /> support@serenatti.com
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10">
          <p data-testid="footer-disclaimer" className="text-xs text-white/60 leading-relaxed max-w-4xl">
            Educational information only. This site does not provide medical
            advice, diagnosis, or treatment, and does not offer products or
            services. Always consult your own healthcare provider.
          </p>
          <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <p className="text-xs text-white/50 tracking-wide">
              &copy; {new Date().getFullYear()} SERENATTI. All rights reserved.
            </p>
            <p className="text-xs text-white/50">
              Written by a registered nurse.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
